// lib/toast.js
'use client'

import { toast } from 'react-toastify'

export const showToast = (message, type = 'success') => {

  const toastOptions = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  }

  switch (type) {
    case 'success':
      toast.success(message, toastOptions)
      break
    case 'error':
      toast.error(message, toastOptions)
      break
    case 'warning':
      toast.warning(message, toastOptions)
      break
    case 'info':
      toast.info(message, toastOptions)
      break
    default:
      toast(message, toastOptions)
  }
}